import * as Yup from 'yup';

export const UploaderConnectionSchema = Yup.object().shape({
  store_id: Yup.string().required(),
  connection_id: Yup.string().required(),
  client_type: Yup.string().required(),
  // hostname and client_version are `json:"...,omitempty"` and can be absent:
  // older Companion builds don't report client_version, and web connections
  // carry no hostname. `.defined()` would reject the missing key and drop the
  // whole connection, so default to '' instead.
  hostname: Yup.string().default(''),
  user_id: Yup.string().required(),
  client_version: Yup.string().default(''),
  connected_at: Yup.date().required(),
  uploader: Yup.object()
    .shape({
      machine_id: Yup.string().defined(),
      is_server: Yup.boolean().required(),
      rcv_blocked: Yup.boolean().optional(),
    })
    .optional(),
});

export type UploaderConnection = Yup.InferType<typeof UploaderConnectionSchema>;

/** A connection with a confirmed uploader (companion). */
export type Companion = UploaderConnection & {
  uploader: NonNullable<UploaderConnection['uploader']>;
};
